import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ShButtonComponent } from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-table-button',
    templateUrl: './table-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule, ShButtonComponent]
})
export class TableButtonComponent {
    @Input() text: string;
    @Input() translate = false;
    @Input() type: 'primary' | 'secondary' | 'tertiary';
    @Output() buttonClick: EventEmitter<boolean> = new EventEmitter<boolean>();

    public clicked(event: PointerEvent): void {
        event.stopPropagation();
        this.buttonClick.emit();
    }
}
